import { render, staticRenderFns } from "./ElementForm.vue?vue&type=template&id=72bbde9d&"
import script from "./ElementForm.vue?vue&type=script&lang=js&"
export * from "./ElementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72bbde9d')) {
      api.createRecord('72bbde9d', component.options)
    } else {
      api.reload('72bbde9d', component.options)
    }
    module.hot.accept("./ElementForm.vue?vue&type=template&id=72bbde9d&", function () {
      api.rerender('72bbde9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/form/ElementForm.vue"
export default component.exports